module.exports = "/static/assets/236f257f6b85917b5ba65dc9e4bb75df.png";